// extracted by mini-css-extract-plugin
export var project = "homepage-project-module--project--3r8OW";
export var content = "homepage-project-module--content--tujgX";
export var imageContainer = "homepage-project-module--imageContainer--WRuTg";